import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Typography, Button } from 'antd';
import useTranslation from 'utils/hooks/useTranslation';
import ExtendedModal from 'components/Shared/Modal/index.js';
import { ROUTE_SALESFORCE_INVOICES } from 'constants.js';
import styles from './style.module.scss';

export default function SubscriptionInvoicesAnnouncementModal() {
  const history = useHistory();
  const { translateText } = useTranslation();
  const currentUserId = useSelector(state => state.user.id);
  const invoiceAnnouncementModalDisplayed = localStorage.getItem(
    'invoiceAnnouncementModalDisplayed',
  );
  const shouldShow =
    !invoiceAnnouncementModalDisplayed || currentUserId !== invoiceAnnouncementModalDisplayed;
  const [showModal, setShowModal] = useState(shouldShow);

  const handleDismiss = () => {
    localStorage.setItem('invoiceAnnouncementModalDisplayed', currentUserId);
    setShowModal(false);
  };

  const handleGoToSalesforceInvoicesPage = () => {
    handleDismiss();
    history.push(ROUTE_SALESFORCE_INVOICES);
  };

  return (
    <ExtendedModal
      title={translateText('corporateAccounts.salesforceInvoices.availableNotice.title')}
      modalTitleStyle="centerAligned"
      titleLevel={4}
      width={565}
      visible={showModal}
      centered
      closable={false}
      confirmLoading={false}
      footer={[
        <div key="footer" className={styles.footerButtons}>
          <Button
            key="cancel"
            onClick={handleDismiss}
            className={`${styles.sharedButton} ${styles.cancelButton}`}
            data-testid="close"
          >
            {translateText('corporateAccounts.common.status.close')}
          </Button>
          <Button
            key="ok"
            onClick={handleGoToSalesforceInvoicesPage}
            type="primary"
            className={styles.sharedButton}
            data-testid="gotoInvoices"
          >
            {translateText('corporateAccounts.salesforceInvoices.availableNotice.viewInvoices')}
          </Button>
        </div>,
      ]}
      className={styles.redirectModal}
    >
      <Typography className={styles.redirectModalContent}>
        {translateText('corporateAccounts.salesforceInvoices.availableNotice.desc')}
      </Typography>
    </ExtendedModal>
  );
}
